import GeneralCustomizations from '../GeneralCustomizations.vue';
<template>
  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
    <GeneralCustomizations />
    <img
      style="width: 100%"
      src="https://cdn-serviceshift.s3.amazonaws.com/production/assets/invoice_pdf_template.png"
    />
  </div>
</template>

<script setup lang="ts">
import GeneralCustomizations from "../GeneralCustomizations.vue";
</script>

<style lang="scss" scoped></style>
